/**
 * Embed helpers.
 *
 * The Swiper can be embedded via <iframe> on an external page (e.g. the VDL
 * interface). In that case we hide AFI's own chrome (top navigation bar, the
 * "exit to project" buttons) so only the clean Swiper remains.
 */

/**
 * True when the app is rendered inside an <iframe> (framed by another page).
 * Access to `window.top` can throw in some cross-origin sandboxes — that also
 * means we are framed, so treat a throw as "embedded".
 */
export function isEmbedded(): boolean {
  try {
    return window.self !== window.top
  } catch {
    return true
  }
}
